export default "__VITE_ASSET__Cnmj7fd1__"